import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=6c31eee2&scoped=true&"
import script from "./Add.vue?vue&type=script&lang=js&"
export * from "./Add.vue?vue&type=script&lang=js&"
import style0 from "./Add.vue?vue&type=style&index=0&id=6c31eee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../salespro-dev/salespro-dev/sources/client/salespro-dev-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c31eee2",
  null
  
)

export default component.exports